import React, { Fragment, FunctionComponent, MouseEvent } from "react";

type PointProps = {
    readonly cx: number;
    readonly cy: number;
    readonly className: string;
    readonly invisiblePointClassName: string;
    readonly onMouseUp?: (e: MouseEvent<SVGCircleElement>) => void;
    readonly onMouseDown: (e: MouseEvent<SVGCircleElement>) => void;
};

export const Point: FunctionComponent<PointProps> = ({ cx, cy, className, invisiblePointClassName, onMouseUp, onMouseDown }) => (
    <Fragment>
        <circle // viditelný bod na plátně
            r="3"
            {...{ cx, cy, className }} />
        <circle // neviditelný bod na plátně, rozšiřující klikatelnou oblast
            r="6"
            className={invisiblePointClassName}
            {...{ cx, cy, onMouseUp, onMouseDown }} />
    </Fragment>
);
